module.exports = __webpack_public_path__ + "img/loading_dots.659a4777.gif";